import { InputAdornment, TextField, makeStyles } from "@material-ui/core";
import React, { useState, useEffect, useRef } from "react";

import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const useCalendarStyles = makeStyles({
  '@global': {
    '.react-datepicker__day--today:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):not(.react-datepicker__day--in-range)': {
      boxShadow: 'inset 0 0 0 1.5px #084e4e !important',
      borderRadius: '50% !important',
      fontWeight: 'bold !important',
    },
    '.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--disabled)': {
      backgroundColor: '#a0e7e7 !important',
      borderRadius: '50% !important',
      color: '#084e4e !important',
    },
    '.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--disabled):hover': {
      backgroundColor: '#a0e7e7 !important',
      color: '#084e4e !important',
    },
    '.react-datepicker__day--selecting-range-start:not(.react-datepicker__day--disabled), .react-datepicker__day--selecting-range-end:not(.react-datepicker__day--disabled)': {
      backgroundColor: '#084e4e !important',
      borderRadius: '50% !important',
      color: '#ffffff !important',
    },
    '.react-datepicker__day--disabled': {
      backgroundColor: '#E2E8F0 !important',
      borderRadius: '50% !important',
      color: '#94A3B8 !important',
      cursor: 'not-allowed !important',
    },
    '.react-datepicker__day--disabled:hover': {
      backgroundColor: '#E2E8F0 !important',
      color: '#94A3B8 !important',
    },
  },
});

const CustomDateInput = React.forwardRef(
  function CustomDateInput(inputProps, ref) {
    const {
      value: inputValue,
      onClick,
      pickerPlaceholder,
      error,
      label,
      required,
      small,
    } = inputProps;
    return (
      <TextField
        ref={ref}
        placeholder={pickerPlaceholder || "DD/MMM/YYYY"}
        style={{
          width: "100%",
          backgroundColor: "transparent",
        }}
        value={inputValue}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment
              style={{ cursor: "pointer" }}
              position="end"
            >
              <CalendarTodayIcon
                onClick={onClick}
                style={{ color: "rgba(0, 0, 0, 0.54)" }}
              />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
        error={!!error}
        onClick={onClick}
        label={required ? <>{label}<span style={{ color: '#d32f2f' }}> *</span></> : label}
        size={small ? "small" : "medium"}
      />
    );
  }
);

export default function CustomDatePickerRange({
  error,
  onChange,
  style,
  label,
  required,
  small,
  placeholderText,
  value,
  ...props
}) {
  let [tempValue, setTempValue] = useState(
    value.some((x) => x !== null)
      ? value.map((date) => new Date(date))
      : [null, null],
  );

  useCalendarStyles();

  useEffect(() => {
    if (value.every((x) => x === null) && tempValue.every((x) => x !== null)) {
      setTempValue([null, null]);
    }
  }, [value, tempValue]);

  const customInput = (
    <CustomDateInput
      pickerPlaceholder={placeholderText}
      error={error}
      label={label}
      required={required}
      small={small}
    />
  );

  return (
    <div
      style={{
        ...style,
        overflow: "inherit",
      }}
    >
      <DatePicker
        {...props}
        selected={tempValue[0]}
        selectsRange
        startDate={tempValue[0]}
        endDate={tempValue[1]}
        onChange={(value) => {
          setTempValue(value);
          onChange(value.map((date) => (date ? new Date(date) : null)));
        }}
        customInput={customInput}
      />
    </div>
  );
}